import React from 'react';
import { Redirect } from 'react-router-dom';
import { SuperAdminOrganizationList } from '../../components/organization-list/super-admin-organization-list';
import { SubOrganizationList } from '../../components/organization-list/sub-organization-list';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import UserUtil from '../../utilities/user-util';
import OrganizationUtil from '../../utilities/organization-util';


const OrganizationsPage: React.FC = () => {
    const { state } = useAuthState();

    const isSuperAdmin = state.claims?.superAdmin === true;

    if (!isSuperAdmin && !UserUtil.isAccountHolder(state.user)) {
        return <Redirect push to="/" />;
    }

    // Org Mgmt (sub-organization management) is an Enterprise / Enterprise
    // Trial feature; guard direct navigation, not just the nav item.
    if (!isSuperAdmin && !OrganizationUtil.supportsSubOrganizations(state.organization)) {
        return <Redirect push to="/" />;
    }

    return (
        isSuperAdmin
            ? <SuperAdminOrganizationList />
            : <SubOrganizationList />
    );
}

// #endregion Component

// -----------------------------------------------------------------------------------------
// #region Exports
// -----------------------------------------------------------------------------------------

export default OrganizationsPage;

// #endregion Exports